export class AgendaMedicaPk {

    idFilial: number = 0;

    idMedico: number = 0;

    diaSemana: number = -1;

    horaAtendimento: string = '';

    constructor() {
    }
}
